<template lang="html">
  <div>
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      right-text=""
      @click-left="onClickLeft"
    />
    <EpisodeList
      :slug="slug"
      :premium-only="true"
      :sale="true"
      :limit="0"
      @got-episodes-count="gotEpisodesCount"
    />
  </div>
</template>

<script>
  import EpisodeList from './episode-list.vue'
  import Vue from 'vue'
  import { NavBar } from 'vant'
  Vue.use(NavBar)
  export default {
    name: "SaleEpisodes",
    components: {
      EpisodeList
    },
    data () {
      return {
        slug: '', // show 的 slug
        title: '特卖专区'
      }
    },
    methods: {
      gotEpisodesCount (count) {
        this.title = `${this.title} (${count})`
      },
      onClickLeft () {
        this.$router.replace({
          name: 'ShowDetail',
          params: {
            slug: this.slug
          }
        })
      }
    },
    mounted () {
      this.slug = this.$route.params.slug
    }
  }
</script>

<style lang="css" scoped>
</style>
